export default __webpack_public_path__ + "static/media/039-rank.0def8c6e.png";